<script>
  import { External, M } from '../../../../../external';

  export let data = { email: { id: -1, type: '', subject: '', link: '' } },
    contact;

  const id = data?.email?.id || -1;
  const type = data?.email?.type || '';
  const subject = data?.email?.subject || '';
  const link = data?.email?.link || '';

  const clickHandler = () => {
    switch (type) {
      case External.CRM_MESSAGE_TYPE.AUTOMATION:
        External.CPanel.goToUrl('/me/crm/marketing/automation?id=' + id);
        break;
      case External.CRM_MESSAGE_TYPE.CAMPAIGN:
        External.CPanel.goToUrl('/me/crm/marketing/campaign/overview?id=' + id);
        break;
      case External.CRM_MESSAGE_TYPE.INDIVIDUAL:
      case External.CRM_MESSAGE_TYPE.INDIVIDUAL_SCHEDULED:
        External.Tools.showWebsitePreviewPopup({
          url:
            'https://' +
            External.userDomain +
            '/me/email?action=previewIndividualEmail&preview=1&history=1&email=' +
            contact.email +
            '&id=' +
            id,
          buttonText: M.SHOW_IN_NEW_TAB,
          onButtonAction: function (pageUrl) {
            let win = window.open(pageUrl, '_blank');
            win.focus();
          },
          customClass: 'individual-email-preview'
        });
        break;
    }
  };
</script>

{#if link}
  <a class="blue-text" href="{link}">{link}</a>
{:else}
  <a class="blue-text" on:click={clickHandler}>"{subject}"</a>
{/if}
